import {useApiClient} from "./client";

export function useExchangeRatesApi() {
	const api = useApiClient();

	return {
		getExchangeRates: () => api.get("/api/v2/exchange-rates"),
	};
}
